"use strict";

import Page from "./components/AllProperties/AllProperties.jsx";

export const auth = true;
export const title = "All Properties";
export const Component = Page;
